module.exports = __webpack_public_path__ + "static/05-496bda6be3597e1782ce87eae402e47e.jpg";